import { Coordinate } from "../types/coordinate";

export interface GeolocationOptions {
  enableHighAccuracy?: boolean;
  timeout?: number;
  maximumAge?: number;
}

export interface GeolocationError {
  code: number;
  message: string;
}

export interface GeolocationResult {
  success: boolean;
  data?: Coordinate;
  error?: GeolocationError;
}

const DEFAULT_OPTIONS: PositionOptions = {
  enableHighAccuracy: true,
  timeout: 5000,
  maximumAge: 10000,
};

/**
 * Check if geolocation is supported by the browser
 */
export const isGeolocationSupported = (): boolean => {
  return "geolocation" in navigator;
};

/**
 * Get current position using the Geolocation API
 */
export const getCurrentPosition = (
  options: GeolocationOptions = {}
): Promise<GeolocationResult> => {
  return new Promise((resolve) => {
    if (!isGeolocationSupported()) {
      resolve({
        success: false,
        error: {
          code: -1,
          message: "Geolocation is not supported by this browser",
        },
      });
      return;
    }

    const opts: PositionOptions = {
      ...DEFAULT_OPTIONS,
      ...options,
    };

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const coordinate: Coordinate = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };

        console.log(`coords: ${coordinate.lat}, ${coordinate.lng}`);

        resolve({
          success: true,
          data: coordinate,
        });
      },
      (error) => {
        // err.code: 1=permission denied, 2=position unavailable, 3=timeout
        console.log(`${error.message} (code ${error.code})`);

        resolve({
          success: false,
          error: {
            code: error.code,
            message: error.message,
          },
        });
      },
      opts
    );
  });
};

export const getLocationBrowserInstruction = () => {
  const userAgent = navigator.userAgent;
  console.log("userAgent", userAgent);
  if (userAgent.indexOf("Chrome") > -1 && userAgent.indexOf("Safari") > -1) {
    return "location_permission_chrome";
  } else if (userAgent.indexOf("Safari") > -1) {
    if (userAgent.includes("Mobile")) {
      return "location_permission_safari_mobile";
    } else {
      return "location_permission_safari_desktop";
    }
  } else return "location_permission_generic";
};
